import { memo, type PropsWithChildren } from 'react';
import { Box, styled } from '@mui/material';

const Footer = styled(Box)({
  position: 'sticky',
  bottom: 0,
  padding: 16,
  display: 'flex',
  gap: 8,
  justifyContent: 'space-between',
});

export const DrawerFooter = memo(({ children }: PropsWithChildren) => {
  return <Footer>{children}</Footer>;
});
